module.exports = __webpack_public_path__ + "img/49.f10baf30.png";